import React from 'react';
import { useNavigate } from 'react-router-dom';

const FigmaNavigation = () => {
  const navigate = useNavigate();

  return (
    <nav style={{
      width: '100%',
      height: '96px',
      backgroundColor: '#FFFFFF',
      padding: '16px 48px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #f0f0f0',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    }}>
      {/* Logo */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer'
      }} onClick={() => navigate('/')}>
        <img 
          src="/UnisynHub/Assets/Group 8.svg" 
          alt="BareBiologics Logo" 
          style={{
            width: '59px',
            height: '64px',
          }}
        />
        <span style={{
          fontSize: '20px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '500',
          color: '#01544E',
        }}>
          BareBiologics
        </span>
      </div>

      {/* Navigation Links */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '32px',
      }}>
        <a href="#/" style={{
          color: '#333333',
          fontSize: '16px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '400',
          textDecoration: 'none',
        }}>Home</a>
        <a href="#about" style={{
          color: '#333333',
          fontSize: '16px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '400',
          textDecoration: 'none',
        }}>About Us</a>
        <a href="#/products" style={{
          color: '#333333',
          fontSize: '16px',
          fontFamily: 'Poppins, sans-serif',
          fontWeight: '400',
          textDecoration: 'none',
        }}>Products</a>
        
        <a 
          href="#/login" 
          style={{
            padding: '14px 32px',
            backgroundColor: '#FFFFFF',
            border: '2px solid #039582',
            borderRadius: '43px',
            color: '#039582',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '600',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#039582';
            e.target.style.color = '#FFFFFF';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#FFFFFF';
            e.target.style.color = '#039582';
          }}
        >
          Sign In
        </a>
        <a 
          href="#/signup" 
          style={{
            padding: '14px 32px',
            backgroundColor: '#039582',
            border: '2px solid #039582',
            borderRadius: '43px',
            color: '#FFFFFF',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '600',
            textDecoration: 'none',
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#027A6B';
            e.target.style.borderColor = '#027A6B';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#039582';
            e.target.style.borderColor = '#039582';
          }}
        >
          Sign Up
        </a>

        {/* User Icon */}
        <div style={{
          width: '48px',
          height: '48px',
          backgroundColor: '#FFFFFF',
          borderRadius: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          border: '1px solid #f0f0f0'
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="#1a1a1a" strokeWidth="1.5"/>
            <path d="M20.59 22C20.59 18.13 16.74 15 12 15C7.26 15 3.41 18.13 3.41 22" stroke="#1a1a1a" strokeWidth="1.5"/>
          </svg>
        </div>

        {/* Shopping Cart */}
        <div style={{
          width: '34px',
          height: '34px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
            <rect x="1" y="1" width="24" height="24" rx="2" stroke="#1a1a1a" strokeWidth="1.5"/>
          </svg>
        </div>
      </div>
    </nav>
  );
};

export default FigmaNavigation;
